import { Button } from '@bpinternal/ui-kit-next'
import { Link } from '~/elements'
import { Lock } from 'lucide-react'
import botAccessControl from '~/assets/bot-access-control.svg'

type Props = {
  workspaceId: string
}

export const AccessControlUpsell = ({ workspaceId }: Props) => {
  return (
    <div className="flex flex-col gap-6 rounded-lg bg-neutral-50 p-12 md:flex-row md:items-center md:justify-between">
      <div className="flex max-w-96 flex-col">
        <div className="flex items-center gap-2">
          <Lock className="rounded-md bg-neutral-300 p-1 text-white" />
          <span className="text-xs text-muted-foreground">RBAC</span>
        </div>

        <div className="mt-5 flex flex-col gap-3">
          <h2 className="text-4xl font-semibold">Access Control</h2>

          <p className="text-sm text-muted-foreground">
            Control which users have access to this bot within your Workspace. Available on Team plans and up.{' '}
            <a
              href="https://www.botpress.com/docs/learn/get-started/dashboard/workspace/settings/members"
              target="_blank"
              rel="noopener noreferrer"
              className="underline"
            >
              Learn more
            </a>
          </p>

          <Link to="/workspaces/$workspaceId/billing" className="w-fit" params={{ workspaceId }}>
            <Button>Upgrade to Team</Button>
          </Link>
        </div>
      </div>
      <div
        className="min-h-48 w-full flex-shrink-0 bg-contain bg-no-repeat md:w-96"
        style={{ backgroundImage: `url(${botAccessControl})` }}
      ></div>
    </div>
  )
}
